const name = "澳門活力旅行社"
const area_code = ["853","852","86"]
const authentication = { "type" : "web", "username" : "web", "userpass" : "@)!(webpass" }
const msg_duration = 1500
const secret_key = "Guo!^*APP"
const login_back = null
const orders_status = { "-2":"已取消","-1":"待確認","0":"待付款","1":"已付款" }
const no_pic = 'http://api.eta.mo/static/images/nobody.jpg'
const accounts_pic = 'http://api.eta.mo/static/images/accounts_header.jpeg'
const upload_url = 'http://api.eta.mo'
const baidu_ak = "8Hve64XkmSqdtRmVqcHzpUjel6WXuTFl"
const lang = "TC"
export default {
    name,area_code,authentication,secret_key,login_back,orders_status,no_pic,accounts_pic,upload_url,baidu_ak,lang,msg_duration
}


// WEBPACK FOOTER //
// ./src/utils/variable.js